const digest = '3e3237f90f3d266ab157c3fcce25af1bd7bd58ab1899562362de8bdf918ebe84';
const css = `._waitListButton_1plmx_1{background-color:#006fcf;text-decoration:none}._waitListButton_1plmx_1:hover{background-color:#0062b6;border-color:#0062b6}._waitListButton_1plmx_1:active{text-decoration:none}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'waitListButton': '_waitListButton_1plmx_1' };
export const waitListButton = '_waitListButton_1plmx_1';
export { css, digest };